export enum SwitchType {
	Verified = 'VERIFIED',
	Unverified = 'UNVERIFIED',
	Stale = 'STALE',
	Expired = 'EXPIRED',
}

/** One side of a switch, at the level of detail the list returns. */
export type TrackedSwitchProduct = {
	mpc: string | null
	manufacturer: string | null
	description: string | null
}

/** A detected switch: a customer moved off one product onto another. */
export type TrackedSwitch = {
	id: string
	switchDate: string // YYYY-MM-DD
	switchType: SwitchType
	/** What this row's money is in; a switch is priced in one currency and never converted. */
	currency: string
	monthlyRebate: number | null
	monthlyRebateActual: number | null
	annualPeriodMonths: number | null
	annualRebate: number | null
	customerLocation: string | null
	customerParent: string | null
	from: TrackedSwitchProduct
	to: TrackedSwitchProduct
}
